import { useEffect, useState } from "react";
import SurveyPreview from "../Components/SurveyPreview";
import { ApiHandler } from "../../Constants/ApiHandler";
import { useParams } from "react-router-dom";
import { SurveyPreviewPropsTypes } from "../SurveyPreviewPropsTypes";
import { NotificationManager } from "react-notifications";
import { commonProps } from ".././../commonTypes";
import { EnumSurveyAnswerStatus } from "../../Common/Enums/EnumsTypes";

function SurveyPreviewContainer() {
  const { id } = useParams() as { id: string };
  const surveyId: string = id;
  //state-mainatined-for-all-supplier-and-survey-infos
  const [surveyAnswersInfo, setSurveyAnswersInfo] = useState<
    SurveyPreviewPropsTypes["surveyAnswersInfo"]
  >({} as SurveyPreviewPropsTypes["surveyAnswersInfo"]);
  const [isSurveyLoaded, setIsSurveyLoaded] = useState(false);
  const [questionObjVariable, setQuestionObjVariable] = useState(
    {} as commonProps["Question"]["questionObj"]
  );
  const surveyAnswers = {};
  //get-survey
  useEffect(() => {
    if (surveyId) {
      (async () => {
        try {
          const response = await ApiHandler.getSurvey(surveyId);
          setSurveyAnswersInfo({
            surveyInfo: {
              ...surveyAnswersInfo.surveyInfo,
              endDate: response?.results?.endDate,
              surveyName: response.results.surveyName,
              questionsInfo: response.results.questionsInfo,
              additionalInfo: {
                note: response.results.additionalInfo.note,
                description: response.results.additionalInfo.description,
              } as SurveyPreviewPropsTypes["surveyAnswersInfo"]["surveyInfo"]["additionalInfo"],
            },
            surveyStatus: EnumSurveyAnswerStatus.NONE,
            activated: response.results.additionalInfo.enableSurvey,
            companyInfo: response.results.companyInfo,
            supplierInfo: {
              companyDetails: {
                industryType: "-",
                employeeRange: 0,
                companyName: "-",
              },
            } as SurveyPreviewPropsTypes["surveyAnswersInfo"]["supplierInfo"],
          } as SurveyPreviewPropsTypes["surveyAnswersInfo"]);

          setQuestionObjVariable({
            ...response.results.questionsInfo.questionObj,
          });
          setIsSurveyLoaded(true);
        } catch (error) {
          NotificationManager.warning("some error has occured", "", 2000);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyId]);

  return (
    <SurveyPreview
      surveyAnswersInfo={surveyAnswersInfo}
      surveyAnswers={surveyAnswers}
      isSurveyLoaded={isSurveyLoaded}
      questionObjVariable={questionObjVariable}
    />
  );
}
export default SurveyPreviewContainer;
